import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  getOrderList: body => {
    return httpApi.postDataViaApi({
      url: api.order.getOrderList,
      body
    })
  },
  getOrderDetail: body => {
    body.isPwa = true
    return httpApi.postDataViaApi({
      url: api.order.getOrderDetail,
      body
    })
  },
  processQuotation: body => {
    body.isPwa = true
    return httpApi.putDataViaApi({
      url: api.order.processQuotation,
      body
    })
  },
  createOtp: body => {
    return httpApi.postDataViaApi({
      url: api.order.createOtp,
      body
    })
  },
  validateOtp: body => {
    return httpApi.postDataViaApi({
      url: api.order.validateOtp,
      body
    })
  }
}
